export default {
    matches: 'matches',
    tournaments: 'tournaments',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modules/sportOffer/search/sectionIds.ts